import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export function SectionHeader({
  id,
  defaultMessage,
  count,
}: {
  id: string;
  defaultMessage: string;
  count: number;
}) {
  return (
    <Typography
      variant="subtitle1"
      sx={{
        color: 'text.secondary',
        mb: 1,
        fontSize: '0.9rem',
      }}
    >
      <FormattedMessage id={id} defaultMessage={defaultMessage} values={{ count }} />
    </Typography>
  );
}
